import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../shared/http-service.class';
import { MyLBApiConfiguration } from '../mylb-api.configuration';
import { IProgramSummary } from '../interfaces/iprogram-summary.interface';
import { IProgram } from '../interfaces/iprogram.interface';
import { IProgramFrequency } from '../interfaces/iprogram-frequency.interface';

@Injectable({
	providedIn: 'root'
})
export class ProgramService extends HttpService {
	constructor(config: MyLBApiConfiguration) {
		super(config, 'program');
	}

	getAllPrograms(): Observable<IProgram[]> {
		return this.get<IProgram[]>(`${this.serviceUrl}/all`);
	}

	getProgramFrequencies(programId?: number): Observable<IProgramFrequency[]> {
		let url = `${this.serviceUrl}/frequencies`;
		if (programId) {
			url += `?programId=${programId}`;
		}
		return this.get<IProgramFrequency[]>(url);
	}

	getLearnerSummariesForUser(learnerUserID: number): Observable<IProgramSummary[]> {
		return this.get<IProgramSummary[]>(`${this.serviceUrl}/learner/summary/${learnerUserID}`);
	}

	getLearnerSummaries(): Observable<IProgramSummary[]> {
		return this.get<IProgramSummary[]>(`${this.serviceUrl}/learner/summary`);
	}

	getInstructorSummaries(): Observable<IProgramSummary[]> {
		return this.get<IProgramSummary[]>(`${this.serviceUrl}/instructor/summary`);
	}

	getInstructorSummariesById(userId: number): Observable<IProgramSummary[]> {
		return this.get<IProgramSummary[]>(`${this.serviceUrl}/instructor/${userId}`);
	}
}
